import React from 'react';
import { connect } from 'react-redux';

import { EstateSearchRefinementListItem } from "./EstateSearchRefinementListItem";

const InternalEstateSearchRefinementList = ({ attribute, clickHandler, options, filterValues }) => (
    <div className="ais-RefinementList">
        <ul className="ais-RefinementList-list">
            {options && options.filter(option => option.count > 0).map((option) => (
                <EstateSearchRefinementListItem
                    attribute={attribute}
                    clickHandler={clickHandler}
                    option={option}
                    checked={filterValues[attribute].includes('' + option.id)}
                    key={Math.random()}
                />
            ))}
        </ul>
    </div>
);

const mapStateToProps = state => {
    return {
        filterValues: state.filterValues,
    };
};

const EstateSearchRefinementList = connect(
    mapStateToProps,
    null,
)(InternalEstateSearchRefinementList);

export { EstateSearchRefinementList };
